
$soupmail.control.autocomplete = function($config) {
	
	this.config = {
		selector : 'input.autocomplete',
		model : '',
		listArrayKey : '',
		maxResults : 0,
//		filterColumn : 'email',
		column : { name:'id', cssclass:'id', layout:'' },
		onChange : '',
		onResultsLoaded : '',
		requestDelay : 100,		// minimum delay time (milliseconds) between HTTP requests, so as to not overload the server
		minCharactersRequired : 3,
		defaultSearchboxValue : '',
		dataWrapperElem : '',
		dataRowElem : 'div',
		dataItemRowId : '',
		dataItemRowClass : 'autocomplete-result',
		dataItemElem : 'div'
	};
	
	this.timer = 0;
	this.lastValue = '';
	this.items = {};
	this.destroy = destroy;
	this.reset = reset;
	this.load = load;
	this.change = change;
	this.resultsLoaded = resultsLoaded;
	this.bind = bind;
	this.unbind = unbind;
	this.render = render;
	this.renderItemRow = renderItemRow;
	this.val = val;
	this.show = show;
	this.hide = hide;
	this.toggle = toggle;
	this.fadeOut = fadeOut;
	this.size = size;
	
	if ($config) {
		var autocomplete = this;
		jQuery.each($config, function($key, $val) {
			autocomplete.config[$key] = $val;
		});
	}
	
	if (!this.config.defaultSearchboxValue) {
		this.config.defaultSearchboxValue = this.val();
	} else {
		this.val(this.config.defaultSearchboxValue);
	}
	if (!this.config.dataWrapperElem) {
		this.config.dataWrapperElem = 'div';
	}
	
	this.nonFilterableModel_fallback_columns = (this.config.nonFilterableModel_fallback_otherColumns ? this.config.nonFilterableModel_fallback_otherColumns : []);
	this.nonFilterableModel_fallback_columns.push(this.config.column.name);
	
	this.bind();
	
	function destroy() {
		this.val(this.config.defaultSearchboxValue);
		this.reset();
		this.unbind();
	};
	
	function reset() {
		this.items = {};
	};
	
	function load($callback) {
		var autocomplete = this;
		var params = {};
		if (this.config.filterColumn) {
			params['filters['+filterColumn+']'] = this.val();
			if (this.config.maxResults > 0) {
				params.max_results = this.config.maxResults;
			}
		} else {
			params.max_results = 1000;
		}
		$models[this.config.model].getList(params, function($data) {
			if (autocomplete.config.filterColumn) {
				autocomplete.items = $data[autocomplete.config.listArrayKey];
				for (var i in autocomplete.items) {
					autocomplete.items[i]._visible = true;
				}
			} else {
				autocomplete.items = {};
				for (var i in $data[autocomplete.config.listArrayKey]) {
					for (var j in autocomplete.nonFilterableModel_fallback_columns) {
						var k = autocomplete.nonFilterableModel_fallback_columns[j];
						if ($data[autocomplete.config.listArrayKey][i][k] && ($data[autocomplete.config.listArrayKey][i][k].toLowerCase().indexOf(autocomplete.val().toLowerCase()) >= 0)) {
							autocomplete.items[i] = $data[autocomplete.config.listArrayKey][i];
							autocomplete.items[i]._visible = true;
						}
					}
				}
			}
			autocomplete.render();
			autocomplete.resultsLoaded();
		});
	};
	
	function change($func) {
		if (typeof($func) == 'function') {
			this.config.onChange = $func;
		} else {
			clearTimeout(this.timer);
			var colour = ( this.val() ? '#000' : '#c2c2c2' );
			jQuery(this.config.selector).css({'color': colour});
			if (this.val() && ((this.val().length >= this.config.minCharactersRequired) || (this.lastValue.length >= this.config.minCharactersRequired)) && (this.val() != this.lastValue)) {
				var autocomplete = this;
				autocomplete.timer = setTimeout(function() {
					autocomplete.lastValue = autocomplete.val();
					autocomplete.load();
				}, autocomplete.config.requestDelay);
			} else if (this.val() != this.lastValue) {
				this.hide();
			}
			if (typeof(this.config.onChange) == 'function') {
				this.config.onChange();
			}
		}
	};
	
	function resultsLoaded($func) {
		if (typeof($func) == 'function') {
			this.config.onResultsLoaded = $func;
		} else if (typeof(this.config.onResultsLoaded) == 'function') {
			this.config.onResultsLoaded();
		}
	};
	
	function bind() {
		autocomplete = this;
		jQuery(autocomplete.config.selector).focus(function() {
			if (jQuery(autocomplete.config.selector).val() == autocomplete.config.defaultSearchboxValue) {
				jQuery(autocomplete.config.selector).val('');
			}
		});
		jQuery(autocomplete.config.selector).blur(function() {
			if (jQuery(autocomplete.config.selector).val() == '') {
				jQuery(autocomplete.config.selector).val(autocomplete.config.defaultSearchboxValue);
			}
			autocomplete.fadeOut();
		});
		jQuery(autocomplete.config.selector).keyup(function(e) {
			autocomplete.change();
		});
		// if someone hits the Arrow Keys, or ESCAPE or Enter on their keyboard...
		jQuery(document).bind('keyup.autocomplete', function(e) {
			var results = jQuery(autocomplete.config.selector).next('.autocomplete_results');
			var items = results.find('.autocomplete-item');
			var selectedItem = results.find('.autocomplete-item.selected');
			var currentIndex = items.index(selectedItem);
			switch (e.which) {
				case 13: // Enter
					selectedItem.click();
				break;
				case 27: // ESCAPE
					autocomplete.fadeOut();
				break;
				case 38: // Up
					currentIndex--;
					if (currentIndex < 0) { currentIndex = (items.size() - 1); }
					selectedItem.removeClass('selected');
					results.find('.autocomplete-item:eq('+currentIndex+')').addClass('selected');
					return false;
				break;
				case 40: // Down
					currentIndex++;
					if (currentIndex == items.size()) { currentIndex = 0; }
					selectedItem.removeClass('selected');
					results.find('.autocomplete-item:eq('+currentIndex+')').addClass('selected');
					return false;
				break;
				default: return; // exit this handler for other keys
			}
			e.preventDefault();
		});
	};
	
	function unbind() {
		jQuery(this.config.selector).unbind('click');
		jQuery(this.config.selector).unbind('focus');
		jQuery(this.config.selector).unbind('blur');
		jQuery(this.config.selector).unbind('keyup');
		jQuery(document).unbind('keyup.autocomplete');
	};
	
	function render() {
		var html = '';
		var wrapper = '';
		if (this.config.dataWrapperElem) {
			wrapper += '<'+this.config.dataWrapperElem+' class="autocomplete_results">' + "\r\n";
		}
		if (this.config.headersEnabled) {
			html += this.renderHeaderRow() + "\r\n";
		}
		if (this.config.dataItemsWrapperStart) {
			html += this.config.dataItemsWrapperStart + "\r\n";
		}
		for (var i in this.items) {
			if (this.items[i]._visible) {
				html += '<'+this.config.dataRowElem+(this.config.dataItemRowId ? ' id="'+this.config.dataItemRowId.replace('{id}', this.items[i].id)+'"' : '')+' class="'+(this.config.dataItemRowClass ? this.config.dataItemRowClass + ' ' : '') + 'autocomplete-item row-'+this.items[i].id + '" data-id="'+this.items[i].id+'"></'+this.config.dataRowElem+'>';
			}
		}
		if (this.config.dataItemsWrapperEnd) {
			html += this.config.dataItemsWrapperEnd + "\r\n";
		}
		if (this.config.dataWrapperElem) {
			wrapper += '</'+this.config.dataWrapperElem+'>' + "\r\n";
		}
		if (jQuery(this.config.selector).next('.autocomplete_results').size() == 0) {
			jQuery(this.config.selector).after(wrapper);
		}
		jQuery(this.config.selector).next('.autocomplete_results').html(html);
		for (var i in this.items) {
			if (this.items[i]._visible) {
				this.renderItemRow(this.items[i]);
			}
		}
		if (this.size() > 0) {
			this.show();
		} else {
			this.hide();
		}
	};
	
	function renderItemRow($item) {
		var row = '';
		var cssClass = (this.config.column.cssclass ? ' '+this.config.column.cssclass : '');
		if (!this.config.column.hidden) {
			var data = (this.config.column.layout ? this.config.column.layout : '{'+this.config.column.name.replace('.', '_')+'}').replace(/{/gi, '<span class="data_').replace(/}/gi, '"></span>');
			row += '<'+this.config.dataItemElem+' class="value'+cssClass+'">'+data+'</'+this.config.dataItemElem+'>';
		}
		jQuery(this.config.selector).next('.autocomplete_results').find('.row-'+$item.id).html(row);
	//	if (!this.config.column.defaultvalue) {
	//		this.config.column.defaultvalue = '---';
	//	}
		for (var j in autocomplete.nonFilterableModel_fallback_columns) {
			var name = autocomplete.nonFilterableModel_fallback_columns[j];
			if (name) {
				var value = ($item[name] ? $item[name] : this.config.column.defaultvalue);
				if (name.indexOf('.') > 0) {
					var nameParts = name.split('.');
					var namePartsParent = nameParts[0];
					var namePartsChild = nameParts[1];
					value = ($item[namePartsParent] ? $item[namePartsParent][namePartsChild] : this.config.column.defaultvalue);
				}
				if (typeof(this.config.column.onBeforeRender) == 'function') {
					value = this.config.column.onBeforeRender(value, $item);
				}
				jQuery(this.config.selector).next('.autocomplete_results').find('.row-'+$item.id+' span.data_'+name.replace('.', '_')).text(value);
				jQuery(this.config.selector).next('.autocomplete_results').find('.row-'+$item.id+' .autocomplete').children('input, select, textarea').val(value);
			}
		}
		if (typeof(this.config.column.onAfterRender) == 'function') {
			this.config.column.onAfterRender($item, jQuery(this.config.selector).next('.autocomplete_results').find('.row-'+$item.id));
		}
		return row;
	};
	
	function val($value) {
		if (!$value) {
			var val = jQuery(this.config.selector).val();
			return ((val == this.config.defaultSearchboxValue) ? '' : val);
		} else {
			jQuery(this.config.selector).val($value);
		}
	};
	
	function show($visibility) {
		if (typeof($visibility) != 'boolean') {
			$visibility = true;
		}
		if ($visibility) {
			jQuery('.autocomplete_results').show();
		} else {
			jQuery('.autocomplete_results').hide();
		}
	};
	
	function hide() {
		this.show(false);
	};
	
	function toggle() {
		this.show(!jQuery('.autocomplete_results').is(':visible'));
	};
	
	function fadeOut() {
		jQuery('.autocomplete_results').fadeOut('slow');
	};
	
	function size() {
		return jQuery.objectSize(this.items);
	};
	
};



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.control.autocomplete.js